.icon {
  --size: var(--size-icon-icon-text-cell, 18px);

  font-size: var(--size);
  line-height: var(--size);
  color: var(--color-icon-text-cell, initial);
}

.container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.text-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: var(--md-font-size);

  .description {
    font-family: var(--mono-font);
    font-size: var(--sm-font-size);
    color: var(--description-color-icon-text-cell, var(--neutral-7-color));
  }

  .description_regular {
    font-family: var(--regular-font);
  }
}
